import React, { useState, useEffect } from "react";
import { useDispatch } from "react-redux";
import doctorActions from "../../../core/actions/doctorActions";
import MessageStrip from "../../../shared/messagestrip/MessageStrips";
import TextField from "@mui/material/TextField";
import { Grid } from "@mui/material";
import { List } from "@mui/material";
import Button from "@mui/material/Button";
import { Alert } from "@mui/material";
import { helperServices } from "../../../shared/helper";
import { useOrganization } from "../../../configurations/OrganizationContext";
import useDynamicFontFormatter from "../../../shared/helper/useDynamicFontFormatter";

function ChangePassword() {
  const dispatch = useDispatch();
  const org = useOrganization();
  const formatText = useDynamicFontFormatter(org?.fontStyle);
  const [loggedInStaff, setLoggedInStaff] = useState([]);
  const [ServerRes, setServerRes] = useState({ success: "", error: "" });
  const [showMsgStrip, setShowMsgStrip] = useState(false);
  const [messageDetails, setMessageDetails] = useState({});
  const [staffId, setStaffId] = useState("");
  const [formErrors, setFormErrors] = useState({
    password: "",
    confirmPassword: "",
  });
  const [confirmPassword, setConfirmPassword] = useState("");
  const [staffDetail, setstaffDetail] = useState({
    id: "",
    first_name: "",
    mname: "",
    last_name: "",
    phoneno: "",
    area: "",
    city: "",
    state: "",
    pincode: "",
    gender: "",
    bloodgroup: "",
    occupation: "",
    address: "",
    dob: "",
    email: "",
    qualification: "",
    password: "",
  });

  useEffect(() => {
    const loggedUserId = helperServices.getLoggedUserGVID() || "";
    setStaffId(loggedUserId);
    console.log("Logged in staff ID: ", loggedUserId);
  }, []);

  // useEffect(() => {
  //   if (!staffId) return;

  //   dispatch(
  //     doctorActions.fetchStaffById(staffId, (resCb) => {
  //       if (resCb) {
  //         console.log("response from api : ", resCb);
  //         console.log("Logged in Staff : ", resCb?.accresp?.person);
  //         const staff = resCb?.accresp?.person;
  //         setLoggedInStaff(staff);

  //         setstaffDetail((prev) => ({
  //           ...prev,
  //           id: staff.personId,
  //           first_name: staff.first_name,
  //           mname: staff.mname,
  //           last_name: staff.last_name,
  //           phoneno: staff.phoneno,
  //           area: staff.area,
  //           city: staff.city,
  //           state: staff.state,
  //           pincode: staff.pincode,
  //           gender: staff.gender,
  //           bloodgroup: staff.bloodgroup,
  //           occupation: staff.occupation,
  //           address: staff.address,
  //           dob: staff.dob,
  //           email: staff.email,
  //           qualification: staff.qualification,
  //           password: "",
  //         }));
  //       }
  //     })
  //   );
  // }, [staffId]);

  const handleInputChange = (name, value) => {
    setstaffDetail((prev) => ({
      ...prev,
      [name]: formatText(value),
    }));
  };

  const handleConfirmPasswordChange = (value) => {
    setConfirmPassword(value);
  };

  const handleSubmit = (event) => {
    // event.preventDefault();
    // let errors = {};

    // // Validate confirm password manually
    // const confirmError = validateField(
    //   "confirmPassword",
    //   confirmPassword,
    //   true
    // );
    // if (confirmError) errors["confirmPassword"] = confirmError;

    // setFormErrors(errors);

    // if (Object.keys(errors).length === 0) {
    //   // no errors → safe to submit
    //   validateForm();
    // }

    console.log("Not implemented");
  };

  // const toggle = (event) => {
  //   props.history.push("/staffList");
  // };

  const validateField = (fieldName, value, returnError = false) => {
    let error = "";

    // const currentDate = new Date().toISOString().split("T")[0];

    switch (fieldName) {
      case "password":
        error = value ? "" : "Please Enter Password";
        break;
      case "confirmPassword":
        if (!value) error = "Please Enter Confirm Password";
        else if (value !== staffDetail.password)
          error = "Passwords do not match";
        break;
      default:
        break;
    }

    if (returnError) return error;

    setFormErrors((prev) => ({ ...prev, [fieldName]: error }));
  };

  const closeAlert = () => {
    setServerRes({ success: "", error: "" });
  };

  const validateForm = (event) => {
    const payload = { ...staffDetail };
    if (!payload.gender) payload.gender = "Male";

    // if (props.location && props.location.rowData) {
    payload.dob = new Date(payload.dob);
    dispatch(
      doctorActions.modifyDoctor(payload, (resCb) => {
        if (resCb.accresp?.success) {
          setServerRes({ success: "Staff updated Successfully" });
          setTimeout(() => {
            // props.history.push("/staffList");
            closeAlert();
          }, 3000);
        } else if (resCb.accresp?.error) {
          console.log("resCb.accresp?.error", resCb.accresp?.error);
          setServerRes({ error: resCb.accresp?.error });
          setTimeout(() => {
            closeAlert();
          }, 3000);
        }
      })
    );
  };

  const closeMessageStrip = () => {
    setShowMsgStrip(false);
  };

  // Common input style
  const inputStyle = { height: "40px" };

  return (
    <>
      {showMsgStrip && (
        <MessageStrip
          msgStrip={messageDetails}
          closeMessageStrip={closeMessageStrip}
        />
      )}
      {ServerRes.success && (
        <Alert severity="success">{ServerRes.success}</Alert>
      )}
      {ServerRes.error && <Alert severity="error">{ServerRes.error}</Alert>}

      <div className="insuranceFormContainer p-3">
        <h5>Change Password</h5>
        <main className="mainsection">
          <List>
            <div className="p-2 bg-none">
              <form>
                {/* Row 8: Password */}
                <Grid
                  container
                  spacing={2}
                  sx={{ mt: 0 }}
                  className="local-grid-override"
                >
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      type="password"
                      label={"New password"}
                      value={staffDetail.password}
                      onChange={(e) =>
                        handleInputChange("password", e.target.value)
                      }
                      // error={!!formErrors.password}
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.password}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                  <Grid item md={4}>
                    <TextField
                      className="py-2"
                      fullWidth
                      type="password"
                      label="Confirm password"
                      value={confirmPassword}
                      onChange={(e) =>
                        handleConfirmPasswordChange(e.target.value)
                      }
                      // error={!!formErrors.confirmPassword}
                      helperText={
                        <span style={{ color: "#EC4147" }}>
                          {formErrors.confirmPassword}
                        </span>
                      }
                      variant="outlined"
                      InputProps={{ style: inputStyle }}
                    />
                  </Grid>
                </Grid>

                {/* Buttons */}
                <div
                  className="buttonsetconfirm"
                  style={{
                    marginTop: "24px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    gap: "12px",
                  }}
                >
                  <Button
                    variant="contained"
                    color="error"
                    // onClick={toggle}
                    style={{ textTransform: "none" }}
                  >
                    Cancel
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={handleSubmit}
                    style={{ textTransform: "none" }}
                  >
                    Save
                  </Button>
                </div>
              </form>
            </div>
          </List>
        </main>
      </div>
    </>
  );
}

export default ChangePassword;
